/**
 * Authentication Configuration
 *
 * This module defines the authentication-related configuration settings used throughout the application.
 * It includes API endpoints for authentication operations and local storage keys for persisting auth state.
 */

/**
 * Authentication configuration object
 *
 * @property {string} meEndpoint - API endpoint for fetching the current user's profile
 * @property {string} loginEndpoint - API endpoint for user login
 * @property {string} storageTokenKeyName - LocalStorage key for storing the JWT auth token
 * @property {string} userData - LocalStorage key for storing cached user data
 */
const authConfig = {
  meEndpoint: `user/me`, // Endpoint to fetch current user data
  loginEndpoint: "user/login", // Login endpoint path
  storageTokenKeyName: "accessToken", // LocalStorage key for JWT token
  userData: "userData" // LocalStorage key for user profile data
};

export default authConfig;
